import _defineProperty from "/workdir/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React, { useCallback, useContext, useMemo } from 'react';
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
// This context doesn't appear in src/shared/context.ts because it's not supposed to be publicly
// accessible but rather only through this module's exports.
const FoldStatusContext = /*#__PURE__*/React.createContext('unknown');
const IsAboveFoldProvider = _ref => {
  let {
    children,
    foldStatus
  } = _ref;
  const existingStatus = useContext(FoldStatusContext);
  // Optimisation to avoid unnecesarily instantiating a provider
  if (foldStatus === 'unknown') {
    return /*#__PURE__*/_jsx(_Fragment, {
      children: children
    });
  }
  const newStatus = existingStatus === 'below' ? 'below' : foldStatus;
  return /*#__PURE__*/_jsx(FoldStatusContext.Provider, {
    value: newStatus,
    children: children
  });
};
export function withIsAboveFoldProvider(Component, foldStatus) {
  const WithIsAboveFold = props => /*#__PURE__*/_jsx(IsAboveFoldProvider, {
    foldStatus: foldStatus,
    "data-id": "is-above-fold-provider_index_IsAboveFoldProvider",
    children: /*#__PURE__*/_jsx(Component, _objectSpread(_objectSpread({}, props), {}, {
      "data-id": "is-above-fold-provider_index_IsAboveFoldProvider_Component"
    }))
  });
  return WithIsAboveFold;
}

// Bit of a hack to stop too many re-renders of the withIsAboveFoldProvider HOC where
// the parent uses React.cloneElement to pass props to the child (e.g. <Reel>).
export function useWithIsAboveFoldProvider(Component) {
  const componentsByStatus = useMemo(() => ({
    above: withIsAboveFoldProvider(Component, 'above'),
    below: withIsAboveFoldProvider(Component, 'below'),
    unknown: withIsAboveFoldProvider(Component, 'unknown')
  }), [Component]);
  return useCallback(foldStatus => componentsByStatus[foldStatus], [componentsByStatus]);
}
export function useIsAboveFold() {
  return useContext(FoldStatusContext) === 'above';
}
export default IsAboveFoldProvider;